'use client'
import React, { useState, useEffect } from 'react'
import LargePropertyCard from './LargePropertyCard'
const LikeCards = async ({ properties, dictionary, lang }) => {

    return (
        <div className='md:w-full 2xl:w-8/12 sm:min-h-[80vh] min-h-[70vh] flex md:flex-row flex-col flex-nowrap md:flex-wrap mx-auto md:px-3 px-0'>
            <>
                {properties.length > 0 && properties.map((property, index) => (
                    <div
                        key={property.id}
                        className='m-2'
                    >
                        <LargePropertyCard className='m-3'
                            lang={lang}
                            dictionary={dictionary.card}
                            property={property}
                            isLast={index === properties.length - 1}
                            // imageWidth={imageWidth}
                            newLimit={() => { page < allPages ? setPage(page + 1) : setPage(page) }}
                        />
                    </div>
                ))}
            </>
        </div>
    )
}

export default LikeCards